const
  NAME               = 'adverUnfix',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME],
  _window$           = $(window),
  STICKY_TIMER       = 6000,
  SUSCRIPTOR         = 'suscriptor',
  TRIAL              = 'trial',
  BOTTOM             = 'bottom',
  app                = Voonto.getInstance()
;

class AdverUnfix {
  constructor(element$, options) {
    this._element$      = element$;
    this._options       = options;
    this._position      = element$.data('voc-adver-unfix');
    this._elParent$     = element$.parent();
    this._elOffsetTop   = element$.offset().top;
    this._elOuterHeight = element$.outerHeight(true);

    if (this._position === BOTTOM) {
      element$.one('vam:slotrendered', () => {
        app.when('vocuser:ready').then((gigyaux) => {
          var userType = gigyaux.getUserType();
          if (userType !== SUSCRIPTOR && userType !== TRIAL) {
            this._elParent$.addClass('fixed-position');
            setTimeout(() => {
              this._elParent$.removeClass('fixed-position');
            }, STICKY_TIMER);
          }
        });
      });
    } else {
      element$.one('vam:viewable', () => {
        app.when('vocuser:ready').then((gigyaux) => {
          var userType = gigyaux.getUserType();
          if (userType !== SUSCRIPTOR && userType !== TRIAL) {
            _window$.on('scroll.megabanner', this.onScroll.bind(this));
            _window$.trigger('scroll.megabanner');
            setTimeout(() => {
              this._element$.removeClass('fixed-position');
              _window$.off('scroll.megabanner');
              this._elParent$.css('padding-top', '0');
            }, STICKY_TIMER);
          }
        });
      });
    }
  }

  onScroll() {
    if (_window$.scrollTop() + this._options.offset_top > this._elOffsetTop) {
      this._element$.addClass('fixed-position');
      this._elParent$.css('padding-top', this._elOuterHeight + 'px');
    } else {
      this._element$.removeClass('fixed-position');
      this._elParent$.css('padding-top', '0');
    }
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(options) {
    return this.each(function() {
      new AdverUnfix($(this), options);
    });
  }
}

$.fn[NAME]             = AdverUnfix._jQueryInterface;
$.fn[NAME].Constructor = AdverUnfix;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return AdverUnfix._jQueryInterface;
};

export default AdverUnfix;



// WEBPACK FOOTER //
// ./src/plugins/adver-unfix.js